'use strict';

/* globals angular */

/**
 * Files in node_modules, bower_components, and vendor directory should be required here UNLESS
 * they are already being required in the app file. While requiring a component in both places
 * should not break anything it will result in the packaged code containing the source of the
 * component twice.
 *
 * Files should be listed alphabetically if possible.
 */

// ## Core Dependencies
require('es6-object-assign').polyfill();
require('core-js/es6/promise');
require('core-js/modules/es6.array.find');
require('./vendor/modernizr.js');

require('angular');

angular.module('app.templates', []);

require('../node_modules/@skycatch/skydash-saturn/boosters/analytics');
require('../node_modules/@skycatch/skydash-saturn/boosters/button');
require('../node_modules/@skycatch/skydash-saturn/boosters/colorpicker');
require('../node_modules/@skycatch/skydash-saturn/boosters/data');
require('../node_modules/@skycatch/skydash-saturn/boosters/dialog');
require('../node_modules/@skycatch/skydash-saturn/boosters/dropdown');
require('../node_modules/@skycatch/skydash-saturn/boosters/filter');
require('../node_modules/@skycatch/skydash-saturn/boosters/flux');
require('../node_modules/@skycatch/skydash-saturn/boosters/form');
require('../node_modules/@skycatch/skydash-saturn/boosters/layout');
require('../node_modules/@skycatch/skydash-saturn/boosters/list');
require('../node_modules/@skycatch/skydash-saturn/boosters/map');
require('../node_modules/@skycatch/skydash-saturn/boosters/utils');
require('../node_modules/@skycatch/skydash-saturn/boosters/webglRenderer');
require('../node_modules/@skycatch/skydash-saturn/boosters/meshRenderer');
require('../node_modules/@skycatch/saturn-datepicker-booster');
require('@skycatch/saturn-auth-booster')

angular.module('saturn', [
  'saturn.analytics',
  'saturn.button',
  'saturn.colorpicker',
  'saturn.data',
  'saturn.datepicker',
  'saturn.dialog',
  'saturn.dropdown',
  'saturn.flux',
  'saturn.filter',
  'saturn.form',
  'saturn.layout',
  'saturn.list',
  'saturn.map',
  'saturn.utils',
  'saturn.webglRenderer',
  'saturn.meshRenderer'
]);

// ## Secondary Dependencies
require('angular-animate');
require('angular-gettext');
require('angular-jwt');
require('angular-storage');
require('angular-ui-router');
require('angular-stripe-checkout');
require('angular-filter');
require('ng-table');

require('./common');
require('./vendor/dirPagination');
// require('@skycatch/ingestor-ng')

// Vendor dependencies
require('./vendor/intercom.js');
require('./vendor/ui-bootstrap-custom-tpls-1.1.2.min.js');

window.PUBNUB = require('./vendor/pubnub-3.14.5.min.js');

// the main app
require('./app/index.js');
require('./vendor/pubnub-angular-3.2.0.min.js');



// WEBPACK FOOTER //
// ./src/index.js